// import axios from 'axios';
// import { useMsal } from '@azure/msal-react';
// import { toast } from 'react-toastify';
// import { acquireToken, clearCache } from '../auth/authService';

// // Function to generate GUID id
// const generateGUID = () => {
//   return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
//     const r = (Math.random() * 16) | 0;
//     const v = c === 'x' ? r : (r & 0x3) | 0x8;
//     return v.toString(16);
//   });
// };

// const baseurl = process.env.REACT_APP_API1;
// // let tokenStr = localStorage.getItem("accessToken"); // Retrieve token from localStorage

// // let tokenStr = await acquireToken();
// // if (!tokenStr) {
// //   throw new Error("Token acquisition failed. User may need to re-authenticate.");
// // }

// // if (process.env.NODE_ENV === 'test' && !tokenStr) {
// //   tokenStr =  process.env.REACT_APP_MOCK_TOKEN
// // }

// // Create axios instance with default configuration
// const axiosInstance = axios.create({
//   baseURL: baseurl,
//   headers: {
//     // Authorization: tokenStr ? `Bearer ${tokenStr}` : "", // Set Authorization header if tokenStr is not null
//     'X-Correlation-Id': generateGUID(), // Generate X-Correlation-Id header
//     'X-Request-Id': generateGUID(), // Generate X-Request-Id header
//   },
// });

// // Add a request interceptor
// axiosInstance.interceptors.request.use(
//   async (config) => {
//     try {
//       // Acquire token from MSAL
//       // const loginType = tokenManager.getLoginType();

//       // if (loginType === "azure") {
//       const token = await acquireToken();
//       config.headers.Authorization = `Bearer ${token}`;
//       // }

//       // if (loginType === "db") {
//       //   const token = tokenManager.getToken();
//       //   if (token) config.headers.Authorization = `Bearer ${token}`;
//       // }

//       return config;
//     } catch (error) {
//       const { instance } = useMsal();
//       await instance.logout();
//       clearCache(error);
//       throw new Error("Unable to acquire token. Please re-authenticate.");
//     }
//   },
//   (error) => Promise.reject(error),
// );

// // // Add a request interceptor
// // axiosInstance.interceptors.request.use(
// //   (config) => {
// //     // Do something before request is sent, such as adding headers
// //     if (!config.headers.Authorization) {
// //       const newToken = localStorage.getItem("accessToken"); // Retrieve token from localStorage again
// //       config.headers.Authorization = newToken ? `Bearer ${newToken}` : ""; // Set Authorization header if newToken is not null
// //     }
// //     return config;
// //   },
// //   (error) => {
// //     // Do something with request error
// //     return Promise.reject(error);
// //   }
// // );

// // Add a response interceptor
// axiosInstance.interceptors.response.use(
//   (response) => {
//     // Do something with the response data
//     return response;
//   },
//   (error) => {
//     if (error.response && error.response.status === 401) {
//       // Handle 401 unauthorized error
//       localStorage.removeItem("userDetail");
//       // localStorage.removeItem("accessToken");
//       const keysToRemove = Object.keys(localStorage).filter(
//         (key) => key.startsWith("msal.") || key.includes("login.windows.net")
//       );
//       keysToRemove.forEach((key) => {
//         localStorage.removeItem(key);
//       });
//       sessionStorage.clear();
//       if (window.location.pathname !== '/unauthorized') {
//         window.location = "/unauthorized";
//       }
//     } else if (error.response && error.response.status === 412) {
//       toast.error(
//         `${error.response.data.detail}`,
//         { position: "top-right" }
//       );
//     } else if (
//       error.response &&
//       !error.response.data
//     ) {
//       toast.error(
//         `${error.response.status} An unexpected error occurred`,
//         { position: "top-right" }
//       );
//     }
//     // Do something with response error
//     return Promise.reject(error);
//   }
// );

// export default axiosInstance;

import axios from 'axios';
// import { useMsal } from "@azure/msal-react";
import { toast } from 'react-toastify';
import { tokenManager } from '../auth/tokenManager';
import { acquireToken, clearCache } from '../auth/authService';
import apiServices from '../services/service';

let isRefreshing = false;
let failedQueue = [];
const processQueue = (error, token = null) => {
  failedQueue.forEach((p) => {
    if (error) p.reject(error);
    else p.resolve(token);
  });
  failedQueue = [];
};

// Function to generate GUID id
const generateGUID = () => {
  return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
    const r = (Math.random() * 16) | 0;
    const v = c === 'x' ? r : (r & 0x3) | 0x8;
    return v.toString(16);
  });
};

const baseurl = process.env.REACT_APP_API1;
// Create axios instance with default configuration
const axiosInstance = axios.create({
  baseURL: baseurl,
  headers: {
    // Authorization: tokenStr ? `Bearer ${tokenStr}` : "", // Set Authorization header if tokenStr is not null
    'X-Correlation-Id': generateGUID(), // Generate X-Correlation-Id header
    'X-Request-Id': generateGUID(), // Generate X-Request-Id header
  },
});

// Add a request interceptor
axiosInstance.interceptors.request.use(
  async (config) => {
    try {
      // const token = await acquireToken();
      // config.headers.Authorization = `Bearer ${token}`;

      const loginType = tokenManager.getLoginType();

      if (loginType === 'azure') {
        const token = await acquireToken();
        config.headers.Authorization = `Bearer ${token}`;
      }

      if (loginType === 'db') {
        // const token = tokenManager.getToken();
        const token = tokenManager.getAccessToken();
        if (token) {
          config.headers.Authorization = `Bearer ${token}`;
        }
      }

      return config;
    } catch (error) {
      // const { instance } = useMsal();
      // await instance.logout();
      clearCache(error);
      throw new Error('Unable to acquire token. Please re-authenticate.');
    }
  },
  (error) => Promise.reject(error)
);

// axiosInstance.interceptors.response.use(
//   (response) => {
//     // Do something with the response data
//     return response;
//   },
//   async (error) => {
//     if (error.response && error.response.status === 401) {
//       debugger;
//       const refreshToken = localStorage.getItem("refreshToken");
//       const payload = { refreshToken: refreshToken };
//       // const refreshResponse = apiServices.refreshToken(payload);
//       const refreshResponse = await apiServices.refreshToken(payload);
//       const newAccessToken = refreshResponse.data.accessToken;
//       debugger;
//       tokenManager.setToken(newAccessToken);
//       error.config.headers.Authorization = `Bearer ${newAccessToken}`;

//       return axios(error.config); // retry original request
//     } else { }
//     // Do something with response error
//     return Promise.reject(error);
//   },
// );

// RESPONSE INTERCEPTOR
axiosInstance.interceptors.response.use(
  (response) => response,
  async (error) => {
    const originalRequest = error.config;
    if (!error.response) {
      return Promise.reject(error);
    }
    const status = error.response.status;
    const loginType = tokenManager.getLoginType();
    /**
     * -------------------------------------------------
     * AZURE LOGIN HANDLING (OLD WORKING LOGIC)
     * -------------------------------------------------
     */
    if (loginType === 'azure') {
      if (status === 401) {
        clearCache(error);
        if (window.location.pathname !== '/unauthorized') {
          window.location = '/unauthorized';
        }
      } else if (status === 412) {
        toast.error(`${error.response.data.detail}`, { position: 'top-right' });
      } else if (error.response && !error.response.data) {
        toast.error(`${error.response.status} An unexpected error occurred`, {
          position: 'top-right',
        });
      }
      return Promise.reject(error);
    }
    /**
     * -------------------------------------------------
     * DB LOGIN TOKEN REFRESH LOGIC
     * -------------------------------------------------
     */
    if (loginType === 'db' && status === 401 && !originalRequest._retry) {
      originalRequest._retry = true;
      if (isRefreshing) {
        return new Promise((resolve, reject) => {
          failedQueue.push({ resolve, reject });
        })
          .then((token) => {
            originalRequest.headers.Authorization = `Bearer ${token}`;
            return axiosInstance(originalRequest);
          })
          .catch((err) => Promise.reject(err));
      }
      isRefreshing = true;
      try {
        const refreshToken = tokenManager.getRefreshToken();
        if (!refreshToken) throw new Error('Missing refresh token');
        const response = await apiServices.refreshToken({ refreshToken });
        const newAccessToken = response.data.accessToken;
        const newRefreshToken = response.data.refreshToken;
        tokenManager.setTokens(newAccessToken, newRefreshToken);
        processQueue(null, newAccessToken);
        originalRequest.headers.Authorization = `Bearer ${newAccessToken}`;
        return axiosInstance(originalRequest);
      } catch (err) {
        processQueue(err, null);
        tokenManager.clearAll();
        window.location.replace('/login');
        return Promise.reject(err);
      } finally {
        isRefreshing = false;
      }
    }
    return Promise.reject(error);
  }
);

export default axiosInstance;
